import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outbuildings',
  templateUrl: './outbuildings.component.html',
  styleUrls: ['./outbuildings.component.scss']
})
export class OutbuildingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
